module.exports = __webpack_public_path__ + "img/744.7fb50bf0.jpg";